import { useContext } from 'react';
import GeolocationContext from '../components/context/GeoLocationContext';

export const useGeolocation = () => {
    const context = useContext(GeolocationContext);
    if (!context) {
        throw new Error('useGeolocation must be used within a GeolocationProvider');
    }
    return context;
};
